import {
  MobileCoupon_Delete,
  MobileCoupon_GetRow,
  MobileCoupon_MobileNumberSearch,
  MobileCoupon_Update,
} from "../../Server/ApiV2";

export const onGetMobileCoupon_MobileNumberSearch = async (postData) => {
  try {
    const response = await MobileCoupon_MobileNumberSearch(postData);

    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
export const onGetMobileCoupon_GetRow = async (postData) => {
  try {
    const response = await MobileCoupon_GetRow(postData);

    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
export const onGetMobileCoupon_Update = async (postData) => {
  try {
    const response = await MobileCoupon_Update(postData);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
export const onGetMobileCoupon_Delete = async (postData) => {
  try {
    const response = await MobileCoupon_Delete(postData);

    return response;
  } catch (err) {
    console.error("An error occurred:", err);

    return null;
  }
};
